import React from 'react';
import { Card } from '../components/Card';
import { Button } from '../components/Button';
import { AlertCircleIcon, LockIcon } from 'lucide-react';
interface StateScreenProps {
  onAction: () => void;
}
export function SessionExpiredScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-763">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-764">
        <div className="w-12 h-12 bg-amber/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-765">
          <AlertCircleIcon className="w-6 h-6 text-amber" data-id="element-766" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-767">
          Your session has expired
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-768">
          Please log in again to continue reviewing documents.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-769">
          Log In Again
        </Button>
      </Card>
    </div>;
}
export function AccessDeniedScreen({
  onAction
}: StateScreenProps) {
  return <div className="min-h-screen flex items-center justify-center p-4 bg-navy" data-id="element-770">
      <Card className="w-full max-w-md p-8 text-center" data-id="element-771">
        <div className="w-12 h-12 bg-red-500/10 rounded-full flex items-center justify-center mx-auto mb-6" data-id="element-772">
          <LockIcon className="w-6 h-6 text-red-500" data-id="element-773" />
        </div>
        <h2 className="text-2xl font-serif text-white mb-2" data-id="element-774">
          You don't have access to this case
        </h2>
        <p className="text-gray-400 mb-8" data-id="element-775">
          Contact your administrator to request access.
        </p>
        <Button fullWidth onClick={onAction} data-id="element-776">
          Back to Cases
        </Button>
      </Card>
    </div>;
}